import { useForm, useWatch } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

const useHookForm = (props) => {
  const { validationSchema, defaultValues, onSubmitForm } = props
  const resolver = yupResolver(validationSchema)

  const {
    register,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    reset,
    handleSubmit,
    formState: { errors, isDirty, isValid },
    trigger
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver,
    defaultValues
  })

  const watch = useWatch({ control })

  const submitForm = handleSubmit((values, params) => onSubmitForm(values, params))

  return {
    watch,
    errors,
    isDirty,
    isValid,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    register,
    reset,
    submitForm,
    trigger
  }
}

export default useHookForm
